export enum SidebarActionTypes {
  TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR",
}

interface ToggleSidebar {
  type: SidebarActionTypes.TOGGLE_SIDEBAR;
}

export type SidebarAction = ToggleSidebar;
